import React, {type JSX} from 'react';
import {inboundInstructionsModal} from '@lookiero/transport-inbound-instructions-modal';
import {SIZE} from '@lookiero/aurora';

import {useToast} from '@components/_context';
import {getAuth} from '@infra/api/authManager/authManager';
import {proxy} from '@infra/api/fetch/proxy';

const API_LOGISTICS_URL = (): string => proxy('/logistics');

const getAuthToken = async (): Promise<string> => {
  const token = await getAuth();
  return token ?? '';
};

const MountedInboundInstructionsModal = inboundInstructionsModal({
  apiLogisticsUrl: API_LOGISTICS_URL,
  getAuthToken,
});

interface ModalInboundInstructionsProps {
  readonly orderReference?: string;
  readonly orderId?: string;
  readonly isVisible: boolean;
  readonly onClose?: () => void;
  readonly layer?: SIZE;
}

export const ModalInboundInstructions: React.FC<ModalInboundInstructionsProps> = ({
  orderReference,
  orderId,
  isVisible,
  onClose,
  layer,
}): JSX.Element => {
  const toast = useToast();

  return (
    <MountedInboundInstructionsModal
      isVisible={isVisible}
      layer={layer}
      orderId={orderId}
      orderReference={orderReference}
      onClose={onClose}
      notifyError={(message): void => toast.showError({message})}
      notifySuccess={(message): void => toast.showSuccess({message})}
    />
  );
};
